import { render, staticRenderFns } from "./IconSvgInstagram.vue?vue&type=template&id=3935eff1&scoped=true&"
import script from "./IconSvgInstagram.vue?vue&type=script&lang=js&"
export * from "./IconSvgInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935eff1",
  null
  
)

export default component.exports